<template>
  <div class="news">
    <Header
      :headerBgc="state.headerBgc"
      :showLogo="state.showLogo"
      @titleClick="titleClick"
      @menuClick="menuClick"
      :boxShadows="state.boxShadows"
      :title-color="state.titleColor"
    />
    <div class="news_con">
      <div class="top">
        <p data-aos="fade-up" data-aos-duration="1000">{{ $t('news.pageTitle') }}</p>
      </div>
      <!-- 新闻列表 -->
      <div class="news_list">
        <div class="item" v-for="(item, index) in state.newList" :key="index" @click="toDetail(item.id)">
          <div class="left">
            <div class="up">
              <span>{{ item.month }}</span>
              <span>-</span>
              <span>{{ item.day }}</span>
            </div>
            <div class="low">
              {{ item.year }}
            </div>
          </div>
          <div class="line"></div>
          <div class="mid">
            <div class="title">{{ item.title }}</div>
            <div class="tip">{{ item.tip }}</div>
          </div>
          <div class="right">
            <img :src="item.img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <NewFooter />
  </div>
</template>

<script setup>
import { reactive, onMounted, onUnmounted, ref } from 'vue'
import { useAppStore } from '../store/app'
const { t } = useI18n()
const localePath = useLocalePath()
const { activeNum, setActive } = useAppStore()
const router = useRouter()
const { $aos } = useNuxtApp()

useSeoMeta({
  title: t('news.seoTitle'),
  description: t('news.seoDescription'),
  ogTitle: t('news.seoTitle'),
  ogDescription: t('news.seoDescription'),
  ogType: 'website',
})

const lineChange = ref(null)
const state = reactive({
  headerBgc: '',
  showLogo: true,
  titleColor: '#fff',
  boxShadows: '',
  newList: [
    {
      year: '2026',
      month: '01',
      day: '16',
      title: '农工党深圳市委会肖敏静副主委一行莅临晋百慧生物调研指导',
      tip: '2026 年 1 月 14 日下午，农工党深圳市委会副主委、机关办公室主任肖敏静率队莅临深圳市晋百慧生物有限公司（以下简称 “晋百慧生物”）开展专题调研。农工党中央绿色发展工作委员会主任张颖鹤、农工党深圳市医药工作委员会副主任路超、经济工作委员会副主任易祥、法律与社会工作委员会副主任徐进等骨干党员共同参与调研，晋百慧生物董事长于浩洋博士携核心团队热情接待。此次调研旨在服务深圳经济高质量发展大局，进一步助力生物医药产业创新发展。',
      img: '/newsCenter/15.png',
      id: 15 
    },
    {
      year: '2025',
      month: '03',
      day: '04',
      title: '强强联手！晋百慧生物携手国药器械广东公司，共同助力肠癌早期筛查',
      tip: '2025年2月14日，由国药集团广东省医疗器械有限公司携手深圳市晋百慧生物有限公司联合举办的2025年IVD专委会首届会议及创新医疗器械产品推广活动成功闭幕。在此次活动中，国药集团广东省医疗器械有限公司与深圳市晋百慧生物有限公司的合作签署仪式成为焦点，双方共同致力于为肠癌早期检测领域带来新的生机。',
      img: '/newsCenter/14.png',
      id: 14 
    },
    {
      year: '2024',
      month: '09',
      day: '07',
      title: '喜讯！晋百慧生物荣获国家级专精特新“小巨人”资质',
      tip: '国家工业和信息化部于近日隆重公布第6批专精特新“小巨人”企业名单，晋百慧生物荣耀登榜！这份沉甸甸的荣誉，不单单是对晋百慧生物多年来潜心技术研发的高度褒奖，更是对其在关键技术领域实现重大突破的充分肯定。',
      img: '/newsCenter/13.png',
      id: 13 
    },
    {
      year: '2024',
      month: '04',
      day: '29',
      title: '健康中国，检验同行！晋百慧生物亮相2024中国医师协会检验医师年会',
      tip: '2024年4月24日至26日，由中国医师协会、中国医师协会检验医师分会主办，湖北省医师协会、湖北省医师协会检验医师分会协办的“2024中国医师协会检验医师年会暨第十八届全国检验与临床学术会议”在武汉中国光谷科技会展中心隆重召开。',
      img: '/newsCenter/12.png',
      id: 12 
    },
    {
      year: '2024',
      month: '04',
      day: '19',
      title: '重磅！“粪便microRNA（miR‑92a）”入选《中国结直肠肿瘤无创诊断生物标志物应用专家共识》',
      tip: '近日，中华消化内镜杂志发布《中国结直肠肿瘤无创诊断生物标志物应用专家共识（2023，北京）》，“粪便microRNA（miR‑92a）”成功入选本共识。',
      img: '/newsCenter/11.png',
      id: 11
    },
    {
      year: '2024',
      month: '04',
      day: '02',
      title: '谋发展、谱新篇！晋百慧生物精彩亮相第八届全国健康体检质量控制大会',
      tip: '2024年3月31日，由中华医学会杂志社、中华医学会《中华健康管理学杂志》编辑委员会主办，陕西省医学会健康管理学分会、陕西省健康管理质控中心、陕西省健康体检服务协会、西安交通大学第一附属医院承办，中华医学会健康管理学分会学术支持',
      img: '/newsCenter/10.png',
      id: 10
    },
    {
      year: '2024',
      month: '03',
      day: '20',
      title: '引领行业新发展！晋百慧生物精彩亮相CACLP',
      tip: '3月18日，第二十一届中国国际检验医学暨输血仪器试剂博览会（CACLP）在重庆国际博览中心完美收官。',
      img: '/newsCenter/9.png',
      id: 9
    },
    {
      year: '2024',
      month: '01',
      day: '25',
      title: '服务有爱 助残无碍！ 晋百慧生物携手深圳健促会开展助......',
      tip: '为提高残疾人健康水平，引导残疾人关注疾病预防，做到早发现、早治疗',
      img: '/newsCenter/1.png',
      id: 1 
    },
    {
      year: '2023',
      month: '12',
      day: '26',
      title: '从息肉到肠癌——一枚息肉的逆袭史',
      tip: '大肠息肉是肠黏膜表面凸向肠腔的隆起物，就像长在肠管内面的“肉疙瘩”。在肠镜下可看到息肉大小、形态不等，可分布于肠道的某一段，亦可累......',
      img: '/newsCenter/2.png',
      id: 2
    },
    {
      year: '2023',
      month: '12',
      day: '22',
      title: '晋百慧生物助力政府肠癌检测项目',
      tip: '身心健康是享受幸福生活的基础，而随着年龄的增长，肿瘤、高血压等疾病成为影响身心健康的重要因素。',
      img: '/newsCenter/3.png',
      id: 3
    },
    {
      year: '2023',
      month: '11',
      day: '27',
      title: '会议邀请 | 晋百慧生物邀您共聚第二届ZAODX世界肿瘤......',
      tip: '随着社会的不断进步和医学科技的不断发展，癌症早期筛查和预防变得愈发重要。2022年3月，“中华人民共和国国民经济和社会发展第十四个五年规划和2035......',
      img: '/newsCenter/4.png',
      id: 4
    },
    {
      year: '2023',
      month: '11',
      day: '20',
      title: '相聚金陵！晋百慧生物精彩亮相第十六届中国健康服务业大会',
      tip: '巍巍钟山，浩浩长江；山明水秀，虎踞龙蟠。2023年11月19日，由中华医学会、中华医学会健康管理学分会主办，江苏省医学会、江苏省医学会健康管理学......',
      img: '/newsCenter/5.png',
      id: 5
    },
    {
      year: '2023',
      month: '10',
      day: '31',
      title: '产学研融合，共创新蓝图！香港中文大学（深圳）与晋百慧生物联合共建实验室揭牌签约仪式成功举行！',
      tip: '2023年10月29日上午，香港中文大学（深圳）与深圳市晋百慧生物有限公司联合共建实验室揭牌签约仪式在香港中文大学（深圳）行政楼隆重举行。',
      img: '/newsCenter/7.png',
      id: 6
    },
    {
      year: '2023',
      month: '09',
      day: '27',
      title: '深化交流，增进服务！中国食药促进会疫苗及生物制品......',
      tip: '2023年9月19日，中国食药促进会疫苗及生物制品专委会主任委员、疫苗及生物制品质量监测与评价重点实验室主任陆家海教授莅临晋百慧生物。',
      img: '/newsCenter/6.png',
      id: 7
    },
    {
      year: '2023',
      month: '09',
      day: '13',
      title: '“肠治久安”工程惠州市大肠癌公益项目横沥站正式启动！晋百慧生物一起为爱助力',
      tip: '近日，由农工党广东省委会作为指导单位，农工党惠州市委会发起，惠州市第三人民医院、惠州市慈航公益协会主办的“肠治久安”工程惠州市大肠癌筛查公益项目横沥站启动仪式暨大型健康义诊及大肠癌筛查公益活动在横沥镇隆重举行。',
      img: '/newsCenter/8.png',
      id: 8
    },
  ],
})

const titleClick = (id) => {
  if (id == 11) {
    setActive(0)
      navigateTo(localePath(`/about`))
    }else if(id==22){
      setActive(0)
      navigateTo(localePath(`/product`))
    } else if (id == 33) {
      navigateTo(localePath(`/health`))
    } else if (id == 44) {
      setActive(0)
      navigateTo(localePath(`/contact`))
    } else {
      navigateTo(localePath(`/newsCenter`))
    }
}
const menuClick =(e,path)=>{
  let id = +e
    navigateTo(path)
    if(path.includes('/about')){
      setActive(+id-1)
      return
    }
    if(path.includes('/product')){
      state.active = id-6
      setActive(+id-6)
      return
    }
    if(path.includes('/health')){
      return
    }
    if(path.includes('/contact')){
      state.active = id-13
      setActive(+id-13)
      return
    }
}
const toDetail=(index)=>{
    navigateTo(localePath(`/detail/${index}`))
}
function handleScroll() {
  let top = Math.floor(
    document.documentElement.scrollTop || document.body.scrollTop
  )
  if (top >= 80) {
    state.headerBgc = '#fff'
    state.showLogo = false
    state.titleColor = '#000'
    state.boxShadows = '0px 1px 8px 0px rgba(0,0,0,0.09)'
  } else {
    state.headerBgc = ''
    state.showLogo = true
    state.titleColor = '#fff'
    state.boxShadows = ''
  }
}
onMounted(() => {
  state.active = activeNum
  $aos().init({
    easing: 'ease-out-back',
    duration: 2000,
    once: true,
  })
  window.addEventListener('scroll', handleScroll)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
//   localStorage.removeItem('counter')
})
</script>

<style lang="less" scoped>
.news {
  .news_con {
    width: 100%;
    background-color: #fff;
    position: relative;
    .top {
      background: url('../assets/img/news/news_center.png');
      // background: url(https://img-qn.51miz.com/preview/video/00/00/13/58/V-135855-6DF6FF83.jpg);
      background-size: cover;
      background-position: center;
      width: 100%;
      height: 200px;
      p {
        font-size: 18px;
        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
        font-weight: 700;
        color: #fff;
        padding-top: 80px;
        text-align: center;
        transition: transform 0.3s ease, color 0.3s ease;
      }
      .p_act {
        transform: translateY(-30px); /* 鼠标经过时上移文字 */
        color: #333; /* 鼠标经过时加深文字颜色 */
      }
    }
    .news_list{
        margin-top: 20px;
        .item{
            display: flex;
            align-items: center;
            justify-content: center;
            border-top: 1px solid #E2E2E2;
            width: 63%;
            margin: auto;
            // margin-bottom: 10px;
            cursor: pointer;
            position: relative;
            background-image: linear-gradient(to right, #fff 0%, #fff 50%, #fff 50%, #00a0e9 100%);
            background-size: 200% 100%;
            transition: background-position 0.5s ease;
            &:hover {
            animation: fillBackground 1s forwards;
            }
            @keyframes fillBackground {
            0% { background-position: 0 0; }
            // 50% { background-position: 0 20%; }
            100% { background-position: -100% 0; }
            }
             &:hover img {
                  transform: scale(1.1); /* 鼠标经过时放大图片 */
                }
            .bgc{
                background-color: pink;
                background-size: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }
            .left{
                color: #00A0E9;
                text-align: center;
                .up{
                    font-weight: 700;
                }
                .low{
                    margin-top: 6px;
                    width: 24px;
                    height: 10px;
                    line-height: 10px;
                    text-align: center;
                    border: 1px solid #00A0E9;
                }
            }
            .line{
                width: 16px;
                height: 1px;
                background-color: #999999;
                margin: 0 10px;
            }
            .mid{
                .title{
                    font-weight: bold;
                    margin-bottom: 8px;
                }
                .tip{
                    font-size: 6px;
                    color: #666666;
                    width: 292px;
                }
            }
            .right{
                width: 119px;
                height: 74px;
                padding: 10px;
                img{
                   width: 100%;
                   height: 100%;
                   transition: transform 0.3s ease;
                }
            }
            &:last-child{
                margin-bottom: 40px;
            }
        }
    }
  }
}
</style>
